import { Instance } from 'pspdfkit';

export const customiseInlineToolbar = (
  instance: Instance,
  toolbarItems: (instance: Instance) => any[]
) => {
  instance.setInlineTextSelectionToolbarItems(() => toolbarItems(instance));
};
